export const labels = {
  singleCommunityTabs: {
    POSTS: 'Posts',
    MEMBERS: 'Members',
  },
  moderatorPanelTabs: {
    HOME: 'Home',
    FLAGGED: 'Flagged',
    DELETED: 'Deleted',
  },
  flaggedViewTabs: {
    POSTS: 'Posts',
    COMMENTS: 'Comments',
  },
  deletedViewTabs: {
    POSTS: 'Posts',
    COMMENTS: 'Comments',
  },
} as const;
